export const en = {
  nav: {
    home: 'Home',
    about: 'About',
    products: 'Products',
    stories: 'Our Story',
    contact: 'Contact',
  },

  brand: {
    name: 'NestBloom',
    tagline: 'Herbal Urban Fragrance',
    logoText: 'H',
  },

  hero: {
    title: {
      line1: 'Turn Concrete Stress',
      line2: 'Into Herbal Calm',
    },
    subtitle: 'Reed diffusers, room sprays & soy candles — crafted from 100% essential oils in Boston, MA.',
    features: {
      pureOils: 'Pure Essential Oils',
      apartmentReady: 'Apartment-Ready',
      miltonMade: 'Boston Made',
    },
    cta: 'Shop the Collection',
    ctaSecondary: 'Get Early Access',
  },

  about: {
    title: 'Nature in Small Spaces',
    subtitle: 'Scent as a daily ritual for city living',
    description: 'Urban life is loud, fast, and relentless. NestBloom brings the grounding power of herbs into your apartment — through scent alone. No pills, no teas, no routines to maintain. Just open a window, light a candle, or mist your linen — and exhale.',
    benefits: {
      pureOils: {
        title: 'Pure Essential Oils',
        description: '100% natural — lavender, eucalyptus, rosemary, peppermint, vetiver. No synthetic fragrance, no fillers.',
      },
      apartmentReady: {
        title: 'Apartment-Ready',
        description: 'Compact amber glass, no wax drips, no clutter. Designed specifically for small-space city living.',
      },
      miltonMade: {
        title: 'Small-Batch, Boston MA',
        description: 'Hand-poured and blended in our Boston kitchen. Every unit made with care, in batches of 50–200.',
      },
      ritual: {
        title: 'Daily Scent Ritual',
        description: 'Morning focus, midday calm, evening reset. Three blends for three moments in your urban day.',
      },
    },
    philosophy: {
      title: 'Our Philosophy',
      quote: '"Your home should feel like a breath of fresh air — even when you\'re 12 floors up and the city is loud outside. NestBloom was built for exactly that moment."',
    },
  },

  products: {
    title: 'Signature Herb Blends',
    subtitle: 'Three scents. Three moments. One apartment.',
    description: 'Each blend is built around a single feeling — calm, clarity, or focus. Available as reed diffusers ($24–32), room sprays ($16–22), and soy candles ($26–34).',
    formats: {
      diffuser: 'Reed Diffuser',
      spray: 'Room Spray',
      candle: 'Soy Candle',
    },
    buttons: {
      addToCart: 'Add to Cart',
      comingSoon: 'Coming Soon',
      viewDetails: 'Details',
    },
    cart: {
      title: 'Your Cart',
      empty: 'Your cart is empty',
      total: 'Total',
      checkout: 'Checkout',
      continue: 'Continue Shopping',
    },
  },

  stories: {
    title: 'The NestBloom Story',
    subtitle: 'Boston-made for Boston apartments',
    description: 'A brand born out of a Boston apartment, a lot of city stress, and a belief that the simplest things — smell, air, ritual — can change how a space feels.',
    readMore: 'Read More',
    readLess: 'Read Less',
    quote: {
      text: 'The best wellness practice is the one you\'ll actually do every day',
      source: '— NestBloom',
    },
  },

  waitlist: {
    title: 'Get First Access',
    subtitle: 'Launching Spring 2026 in Boston, MA',
    description: 'We\'re bottling our first 100 units now. Join the list and you\'ll get 15% off your first order, plus early access before we hit Etsy.',
    discountOffer: {
      title: 'Launch Offer',
      discount: '15% OFF',
      description: 'Your First Order',
      subtitle: 'For waitlist members only — first 50 signups',
    },
    memberBenefits: 'What you get',
    form: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone (Optional)',
      interests: 'I\'m most interested in',
      referralSource: 'How did you find us?',
      placeholders: {
        name: 'Your name',
        email: 'your@email.com',
        phone: 'Your phone number',
        referralSource: 'Select one',
      },
      interestOptions: {
        diffuser: 'Reed Diffusers',
        spray: 'Room Sprays',
        candle: 'Soy Candles',
        bundle: 'Apartment Reset Kit',
        subscription: 'Refill Subscription',
        all: 'All of the above',
      },
      referralOptions: {
        social: 'Instagram / TikTok',
        friend: 'Friend or Family',
        search: 'Google Search',
        market: 'Local Market',
        other: 'Other',
      },
      newsletter: 'Send me scent tips and launch updates',
      submit: 'Join the Waitlist',
      success: {
        title: 'You\'re on the list!',
        subtitle: 'Welcome to NestBloom',
        message: 'We\'ll reach out before launch with your 15% discount code. Follow us @nestbloomherbal on Instagram and TikTok to stay in the loop.',
      },
    },
    benefits: {
      discount: {
        title: '15% Off Launch',
        description: 'Applied to your first order automatically',
      },
      earlyAccess: {
        title: 'Shop Before Public',
        description: 'Waitlist gets first pick before Etsy launch',
      },
      updates: {
        title: 'Behind the Scenes',
        description: 'Blending updates, new scents & local market dates',
      },
    },
    privacy: 'We respect your inbox. No spam, ever.',
  },

  footer: {
    brand: {
      name: 'NestBloom',
      description: 'Herbal urban fragrance, small-batch and hand-poured in Boston, MA. Turn concrete stress into herbal calm.',
    },
    sections: {
      products: {
        title: 'Products',
        links: {
          diffusers: 'Reed Diffusers',
          sprays: 'Room Sprays',
          candles: 'Soy Candles',
          bundles: 'Apartment Reset Kit',
        },
      },
      about: {
        title: 'Company',
        links: {
          story: 'Our Story',
          ingredients: 'Our Ingredients',
          process: 'How We Make It',
          sustainability: 'Sustainability',
        },
      },
      support: {
        title: 'Support',
        links: {
          contact: 'Contact Us',
          shipping: 'Shipping Info',
          returns: 'Returns',
          faq: 'FAQ',
        },
      },
    },
    newsletter: {
      title: 'Stay in the loop',
      description: 'Launch dates, new blends, and local market pop-ups.',
      placeholder: 'your@email.com',
      subscribe: 'Subscribe',
    },
    contact: {
      email: 'Email',
      address: 'Based in',
      location: 'Boston, MA',
    },
    social: {
      title: 'Follow Along',
      handle: '@nestbloomherbal',
    },
    legal: {
      copyright: '© 2026 NestBloom. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    disclaimer: {
      text: 'NestBloom products are non-edible home fragrances intended for aromatic use only. Not for ingestion. Keep candles away from children and pets.',
    },
  },

  common: {
    loading: 'Loading...',
    close: 'Close',
    back: 'Back',
    next: 'Next',
  },
};
